var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"butikcontainer"},[_c('div',{staticClass:"butik"},[_c('Menu'),_c('router-view',{staticClass:"content"}),_c('div',{staticStyle:{"flex-grow":"0.4"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }